import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span
              className={`text-xl md:text-2xl font-heading font-semibold tracking-wider transition-colors duration-300 whitespace-nowrap ${
                isHome && !scrolled ? 'text-white' : 'text-foreground-900'
              }`}
            >
              长日光阴
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/category/slow-living"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isHome && !scrolled
                  ? 'text-white/80 hover:text-white'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              慢生活
            </Link>
            <Link
              to="/category/time-records"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isHome && !scrolled
                  ? 'text-white/80 hover:text-white'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              时光记录
            </Link>
            <Link
              to="/category/life-aesthetics"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isHome && !scrolled
                  ? 'text-white/80 hover:text-white'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              生活美学
            </Link>
            <Link
              to="/category/sense-of-years"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isHome && !scrolled
                  ? 'text-white/80 hover:text-white'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              岁月感
            </Link>
            <Link
              to="/category/healing-life"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isHome && !scrolled
                  ? 'text-white/80 hover:text-white'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              治愈系生活
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isHome && !scrolled
                  ? 'text-white/80 hover:text-white'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isHome && !scrolled ? 'text-white' : 'text-foreground-800'
            }`}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-4 px-4 flex flex-col gap-3">
            <Link to="/category/slow-living" className="text-sm text-foreground-700 py-2 cursor-pointer">慢生活</Link>
            <Link to="/category/time-records" className="text-sm text-foreground-700 py-2 cursor-pointer">时光记录</Link>
            <Link to="/category/life-aesthetics" className="text-sm text-foreground-700 py-2 cursor-pointer">生活美学</Link>
            <Link to="/category/sense-of-years" className="text-sm text-foreground-700 py-2 cursor-pointer">岁月感</Link>
            <Link to="/category/healing-life" className="text-sm text-foreground-700 py-2 cursor-pointer">治愈系生活</Link>
            <Link to="/about" className="text-sm text-foreground-700 py-2 cursor-pointer">关于我们</Link>
          </div>
        )}
      </div>
    </nav>
  );
}